export default {
	SET_MEAL_MENU(state, payload) {
		state.list = payload;
	}, SET_MEAL_MENU_ITEM(state, payload) {
		state.list[payload.index].times.push(payload.data);
	}
};



// WEBPACK FOOTER //
// ./sources/app/meal-menu/mutations.js